// extracted by mini-css-extract-plugin
module.exports = {"contacts":"ContactsPage_contacts__151Pu","contacts__title":"ContactsPage_contacts__title__3H9e-"};